__turbopack_context__.v({
  "darkText": "Panel-module__HyRHfG__darkText",
  "lightText": "Panel-module__HyRHfG__lightText",
  "panel": "Panel-module__HyRHfG__panel",
});
